import React from 'react';
import { useGamification } from '../../context/GamificationContext';
import { SparklesIcon } from '../../icons/gamification';

const SimpleToast = () => {
  const { simpleToast } = useGamification();
  if (!simpleToast.visible) return null;
  const Icon = simpleToast.icon || SparklesIcon;
  const title = simpleToast.title || simpleToast.message;
  const subtitle = simpleToast.subtitle;
  return (
    <div className="simple-toast animate-fadeInOut text-white flex items-start flex-col min-w-[220px]">
      <div className="flex items-center w-full">
        <Icon className="h-4 w-4 mr-2" />
        <span className="font-semibold">{title}</span>
      </div>
      {subtitle && (
        <span className="text-xs italic mt-0 ml-3 opacity-90">{subtitle}</span>
      )}
    </div>
  );
};

export default SimpleToast; 